import Router from 'next/router';
import { toast } from 'react-toastify';
import i18n from 'locales/fa.json';
import request, { nodeEnv } from 'services/request';
import * as api from 'routes/account.routes';
import { setUaaCookie } from 'utils/component.util';
import { INITIAL_UTM, replace } from 'utils/common.util';
import { ProductsRoute } from 'routes/product.routes';

export const otpRequestAction = async (
  set,
  body,
  referrer,
): Promise<boolean> => {
  const { next } = Router.query;
  set({ otpRequestLoading: true, otpRequestError: false });
  const url = api.LoginWithOtpSecondStep(next, referrer);
  Router.prefetch(url);
  const res = await request.post(
    body.isLogin ? api.RequestOtpV2Url() : api.RequestOtpV1Url(),
    body,
  );
  if (res.ok) {
    set({
      otpRequestLoading: false,
      userPhoneNumber: body.phone_number,
      utm: INITIAL_UTM,
    });
    toast.success(i18n.global.messages.waitCode);
    Router.replace(url, undefined, { shallow: true });
    return true;
  }
  set({ otpRequestLoading: false, otpRequestError: true });
  return false;
};

export const sendOtpAction = async (set, body): Promise<void> => {
  set({ sendOtpLoading: true, sendOtpError: false });
  const url = Router.asPath.split('next=')[1] || ProductsRoute();
  Router.prefetch(url);
  const res = await request.post(api.VerifyOtpV2Url(), body);
  if (res.ok) {
    set({ sendOtpLoading: false });
    const { access, refresh } = res.data.data.token;
    setUaaCookie(access, refresh);
    if (typeof window !== undefined && nodeEnv === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'otpComplete' });
    }
    // we need keep all the query params in next url, if we use Router.query.next automatically removed second param
    Router.replace(url, undefined, { shallow: true });
  }
  set({ sendOtpLoading: false, sendOtpError: true });
};

export const resendCodeAction = async (set, body): Promise<boolean> => {
  set({ resendCodeLoading: true, resendCodeError: false });
  const res = await request.post(api.RequestOtpV1Url(), body);
  if (res.ok) {
    set({ resendCodeLoading: false, userPhoneNumber: body.phone_number });
    return true;
  }
  set({ resendCodeLoading: false, resendCodeError: true });
  return false;
};

export const forgotPasswordAction = async (set, body): Promise<void> => {
  const { next, referrer } = Router.query;
  set({ forgotPasswordLoading: true, forgotPasswordError: false });
  const res = await request.post(api.RequestOtpV1Url(), body);
  if (res.ok) {
    set({ forgotPasswordLoading: false, userPhoneNumber: body.phone_number });
    replace(api.ForgetPasswordSecondStepRoute(next, referrer))();
  } else set({ forgotPasswordLoading: false, forgotPasswordError: true });
};

export const newPasswordAction = async (set, body): Promise<void> => {
  const { next } = Router.query;
  set({ newPasswordLoading: true, newPasswordError: false });
  const res = await request.post(api.VerifyOtpV1Url(), body);
  if (res.ok) {
    set({ newPasswordLoading: false });
    const { access, refresh } = res.data.data.token;
    setUaaCookie(access, refresh);
    replace((next as string) || ProductsRoute())();
  } else set({ newPasswordLoading: false, newPasswordError: true });
};

export const loginPasswordAction = async (set, body): Promise<void> => {
  set({ loginPasswordLoading: true, loginPasswordError: false });
  const url = Router.asPath.split('next=')[1] || ProductsRoute();
  Router.prefetch(url);
  const res = await request.post(api.LoginWithPasswordUrl(), body);
  if (res.ok) {
    set({ loginPasswordLoading: false });
    const { access, refresh } = res.data.data.token;
    setUaaCookie(access, refresh);
    Router.replace(url, undefined, { shallow: true });
  } else set({ loginPasswordLoading: false, loginPasswordError: true });
};

export const setLastVisibilityStatusAction = (
  set,
  lastVisibilityStatus,
): void => {
  set(() => ({ lastVisibilityStatus }));
};

export const getCaptchaAction = async (set): Promise<void> => {
  set({ captchaLoading: true, captchaError: false });
  const res = await request.post(api.CaptchaUrl());
  if (res.ok) {
    set({ captchaLoading: false, captcha: res.data.data });
  } else set({ captchaLoading: false, captchaError: true });
};
